export enum ConfigEnum {
  ConfigData = 'ConfigData',
}
